const STORAGE_KEYS = {
  token: 'authToken',
  roleId: 'rol_id',
  roleName: 'rol_name',
  userName: 'user_name',
  permissions: 'auth_permissions',
  assignedSucursales: 'auth_assigned_sucursales',
  assignedCajas: 'auth_assigned_cajas',
  defaultSucursalId: 'auth_default_sucursal_id'
};

function normalizePermissions(value) {
  return Array.isArray(value) ? value.filter(Boolean) : [];
}

export function setAuthSession({ token, rol_id, rol_name, user_name, permissions = [], assigned_sucursales = [], assigned_cajas = [], default_sucursal_id = null }) {
  if (token) localStorage.setItem(STORAGE_KEYS.token, token);
  if (rol_id !== undefined && rol_id !== null) localStorage.setItem(STORAGE_KEYS.roleId, String(rol_id));
  if (rol_name !== undefined) localStorage.setItem(STORAGE_KEYS.roleName, rol_name || '');
  if (user_name !== undefined) localStorage.setItem(STORAGE_KEYS.userName, user_name || '');
  localStorage.setItem(STORAGE_KEYS.permissions, JSON.stringify(normalizePermissions(permissions)));
  localStorage.setItem(STORAGE_KEYS.assignedSucursales, JSON.stringify(Array.isArray(assigned_sucursales) ? assigned_sucursales : []));
  localStorage.setItem(STORAGE_KEYS.assignedCajas, JSON.stringify(Array.isArray(assigned_cajas) ? assigned_cajas : []));
  if (default_sucursal_id !== undefined && default_sucursal_id !== null) {
    const normalizedSucursalId = Number(default_sucursal_id);
    localStorage.setItem(STORAGE_KEYS.defaultSucursalId, String(normalizedSucursalId));
    localStorage.setItem('sucursal_id', String(normalizedSucursalId));
  }
}

export function clearAuthSession() {
  Object.values(STORAGE_KEYS).forEach((key) => localStorage.removeItem(key));
  localStorage.removeItem('sucursal_id')
  localStorage.removeItem('sucursalId')
}

export function getAuthPermissions() {
  try {
    return normalizePermissions(JSON.parse(localStorage.getItem(STORAGE_KEYS.permissions) || '[]'));
  } catch (_) {
    return [];
  }
}

export function getAssignedSucursales() {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEYS.assignedSucursales) || '[]')
    return Array.isArray(parsed) ? parsed : []
  } catch (_) {
    return []
  }
}

export function getAssignedCajas() {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEYS.assignedCajas) || '[]')
    return Array.isArray(parsed) ? parsed : []
  } catch (_) {
    return []
  }
}

export function getDefaultSucursalId() {
  const value = localStorage.getItem(STORAGE_KEYS.defaultSucursalId)
  const numeric = Number(value)
  return Number.isFinite(numeric) && numeric > 0 ? numeric : null
}

export function getCurrentSucursalIdFromSession() {
  const value = localStorage.getItem('sucursal_id') || localStorage.getItem('sucursalId')
  const numeric = Number(value)
  return Number.isFinite(numeric) && numeric > 0 ? numeric : null
}

export function setCurrentSucursalId(sucursalId) {
  const numeric = Number(sucursalId)
  if (!Number.isFinite(numeric) || numeric <= 0) return false

  const assigned = getAssignedSucursales()
  if (assigned.length && !assigned.some((item) => Number(item?.sucursal_id) === numeric)) {
    return false
  }

  localStorage.setItem('sucursal_id', String(numeric))
  localStorage.setItem('sucursalId', String(numeric))
  return true
}

export function hasPermission(permissionName) {
  return getAuthPermissions().includes(permissionName);
}

export function hasAnyPermission(permissionNames = []) {
  const permissions = getAuthPermissions();
  return permissionNames.some((permissionName) => permissions.includes(permissionName));
}

export function hasAuthToken() {
  return Boolean(localStorage.getItem(STORAGE_KEYS.token));
}
